import jQuery from 'jquery';
import 'jquery-sticky';

export default jQuery(function() {
    jQuery('.js-sticky-header').sticky({
        topSpacing: 0,
        zIndex: 10
    });
});
